import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { GtmClickOutboundLinkClass } from '@fcom/common';
import { ModalButtons } from '@fcom/ui-components';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';

@Component({
  selector: 'fin-am-destination-continue-modal',
  templateUrl: './am-destination-continue-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AmDestinationContinueModalComponent {
  private gtmService = inject(GtmService);

  readonly ModalButtons = ModalButtons;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  open = false;

  @Input()
  bookUrl: string;

  @Output()
  closeModal: EventEmitter<void> = new EventEmitter();

  navigateToAmBooking(): void {
    const fullUrl = `${this.bookUrl}&utm_content=destination_list`;
    this.gtmService.clickOutboundEvent({
      link_url: fullUrl,
      link_classes: GtmClickOutboundLinkClass.DESTINATION_LISTING_CARD,
      outbound: true,
    });
    // open a new am tab
    window.open(fullUrl, '_blank');
  }
}
